import StorePlatformContractWorkflowLoad from "./store-platform-contract-workflow-load";
import StorePlatformContractWorkflowCommon from "./store-platform-contract-workflow-common";
import commentLoad from './platform-contract-comment-load'
import commentPost from './platform-contract-comment-post'

export default () => {
    window.reloadMasterInfo = () => {
        let token = ''
        Array.from(document.getElementsByTagName('meta')).forEach(meta => {
            if (meta.name != 'csrf-token') return
            token = meta.content
        })
        StorePlatformContractWorkflowLoad(token)
    }

    document.addEventListener('DOMContentLoaded', () => {
        StorePlatformContractWorkflowCommon()
        reloadMasterInfo()

        const store_platform_contract_workflow_id = document.getElementById('store_platform_contract_workflow_for_edit_store_platform_contract_workflow_id').value
        const store_platform_contract_id = document.getElementById('store_platform_contract_workflow_for_edit_store_platform_contract_id').value

        Array.from(document.getElementsByClassName('is-invalid')).forEach(elm => {
            if (elm.classList.contains('end_date')) {
                // 終了日を編集可にする
                elm.readOnly = false
            }
        })

        let token = ''
        Array.from(document.getElementsByTagName('meta')).forEach(meta => {
            if (meta.name != 'csrf-token') return
            token = meta.content
        })

        commentLoad(store_platform_contract_id, store_platform_contract_workflow_id, token, 30)
        commentPost(store_platform_contract_id, store_platform_contract_workflow_id, token)
        Array.from(document.getElementsByClassName('comment-reload')).forEach(el => {
            el.addEventListener('click', (e) => {
                commentLoad(store_platform_contract_id, store_platform_contract_workflow_id, token, 30)
            })
        })
    })
}
